export default __webpack_public_path__ + "static/media/Login-amico.138c365b.png";